import PropTypes from 'prop-types';
import React from 'react';
import { FaAmazon, FaMedium, FaPatreon, FaPodcast, FaYoutube } from 'react-icons/fa';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import * as actions from '../actions';
import Helmet from '../components/Helmet';
import NewsForm from '../components/NewsForm';

const NotePage = ({ history, notes, list, setTag }) => (
  <main className="main-content" itemScope itemType="http://schema.org/Book">
    <ReactTooltip effect="solid" />
    <Helmet
      description={`Parker Klein's notes and links for ${list.name} by ${list.author}`}
      title={`${list.name} by ${list.author}`}
    />
    <div className="item mobile-column">
      {list.photo && (
        <img
          className="photo"
          alt={`${list.name} by ${list.author}`}
          height={310}
          itemProp="image"
          src={list.photo}
          width={207}
        />
      )}
      <div className="column">
        <h2 className="title" itemProp="name">
          {list.name}
        </h2>
        <h3 className="author" itemProp="author">
          {list.author}
        </h3>
        <meta itemProp="genre" content={list.tags.join(', ')} />
        <meta itemProp="url" content={`https://www.parkerklein.com${list.path}`} />
        {/* <p className="rating" itemProp="rating">
          Rating: {list.rating}
        </p> */}
        <p className="time" itemProp="timeRequired">
          {list.time} min read
        </p>
        <p className="date" itemProp="dateCreated">
          {list.date}
        </p>
        <div className="row">
          {list.twosLink && (
            <a
              aria-label={`Read ${list.name} by ${list.author} on Twos`}
              className="icon-link twos"
              data-tip={`${list.name} on Twos`}
              href={list.twosLink}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Read ${list.name} by ${list.author} on Twos`}
            >
              <img
                alt="Twos: days, lists, & things"
                src="https://twos.s3.amazonaws.com/twos-thread-background-transparent-300.png"
                height="28px"
                width="20px"
              />
            </a>
          )}
          {list.youtubeLink && (
            <a
              aria-label={`Watch Parker Klein's Notes on ${list.name} by ${list.author} on YouTube`}
              className="icon-link youtube"
              data-tip={`${list.name} on YouTube`}
              href={list.youtubeLink}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Watch Parker Klein's Notes on ${list.name} by ${list.author} on YouTube`}
            >
              <FaYoutube />
            </a>
          )}
          {list.patreonLink && (
            <a
              aria-label={`Support Parker Klein's notes on ${list.name} by ${list.author} on Patreon`}
              className="icon-link patreon"
              data-tip={`${list.name} on Patreon`}
              href={list.patreonLink}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Support Parker Klein's notes on ${list.name} by ${list.author} on Patreon`}
            >
              <FaPatreon />
            </a>
          )}
          {list.link && (
            <a
              aria-label={`Buy ${list.name} by ${list.author} on Amazon`}
              className="icon-link amazon"
              data-tip={`Buy ${list.name} on Amazon`}
              href={list.link}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Buy ${list.name} by ${list.author} on Amazon`}
            >
              <FaAmazon />
            </a>
          )}
          {list.podcastLink && (
            <a
              aria-label={`Listen to Parker Klein's Notes podcast on ${list.name} by ${list.author}`}
              className="icon-link podcast"
              data-tip={`Listen to ${list.name}`}
              href={list.podcastLink}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Listen to Parker Klein's Notes podcast on ${list.name} by ${list.author}`}
            >
              <FaPodcast />
            </a>
          )}
          {list.mediumLink && (
            <a
              aria-label={`Read Parker Klein's notes on ${list.name} by ${list.author} on Medium`}
              className="icon-link medium"
              data-tip={`Read ${list.name} on Medium`}
              href={list.mediumLink}
              itemProp="url"
              rel="noopener noreferrer"
              target="_blank"
              title={`Read Parker Klein's notes on ${list.name} by ${list.author} on Medium`}
            >
              <FaMedium />
            </a>
          )}
        </div>
        {list.tags && (
          <div className="tags">
            {list.tags.sort().map(tag => (
              <button
                className="tag"
                key={tag}
                onClick={() => {
                  setTag(tag);
                  history.push('/notes');
                }}
              >
                {tag}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
    {!!list.podcastLink && (
      <div className="youtube-video">
        <iframe
          title={list.name}
          src={list.podcastEmbed}
          height="102px"
          width="343px"
          frameBorder="0"
          scrolling="no"
        />
      </div>
    )}
    {!!list.youtubeLink && (
      <div className="youtube-video">
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          height="160"
          id={list.youtubeEmbed}
          src={list.youtubeEmbed}
          title={list.name}
          width="288"
        />
      </div>
    )}
    <ul aria-labelledby="notes-list">
      {notes.map((note, i) => (
        <li key={note + i}>
          <p className="note" itemProp="text">
            {note}
          </p>
        </li>
      ))}
    </ul>
    <NewsForm />
  </main>
);

NotePage.propTypes = {
  history: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
  notes: PropTypes.array.isRequired,
  setTag: PropTypes.func.isRequired
};

export default withRouter(connect(null, { ...actions })(NotePage));
